import { render, staticRenderFns } from "./SummaryShop.vue?vue&type=template&id=49a80fda"
import script from "./SummaryShop.vue?vue&type=script&lang=js"
export * from "./SummaryShop.vue?vue&type=script&lang=js"
import style0 from "./SummaryShop.vue?vue&type=style&index=0&id=49a80fda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports